import PartSuitabilityIndicator from './PartSuitabilityIndicator';

export default PartSuitabilityIndicator;
